// language=GraphQL
export const ALL_FIELD_OPTIONS_QUERY = `query Query {
  fieldOptions: customBookingFormFieldOptions {
    id
    value
    label
  }
}`

// language=GraphQL
export const SINGLE_FIELD_OPTION_QUERY = `query Query($id: ID!) {
  fieldOption: customBookingFormFieldOption(id: $id) {
    id
    value
    label
  }
}`

// language=GraphQL
export const CREATE_FIELD_OPTION_MUTATION = `
  mutation Mutation($input: CreateCustomBookingFormFieldOptionInput) {
    fieldOption: createCustomBookingFormFieldOption(input: $input) {
      id
      value
      label
    }
  }`

// language=GraphQL
export const UPDATE_FIELD_OPTION_MUTATION = `
  mutation Mutation($input: UpdateCustomBookingFormFieldOptionInput) {
    fieldOption: updateCustomBookingFormFieldOption(input: $input) {
      id
      value
      label
    }
  }`

// language=GraphQL
export const DELETE_FIELD_OPTION_MUTATION = `
  mutation Mutation($input: DeleteCustomBookingFormFieldOptionInput) {
    deleteCustomBookingFormFieldOption(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_FIELD_OPTION_MUTATION = `
  mutation Mutation($input: DeleteCustomBookingFormFieldOptionInput) {
    forceDeleteCustomBookingFormFieldOption(input: $input) {
      success
    }
  }`
// language=GraphQL
export const FIELD_OPTIONS_DEPENDENTS_QUERY = `query Query($id: ID!, $withCustomBookingFormFields: Boolean = false) {
  groupedDependents: customBookingFormFieldOptionDependents(id: $id) {
    customBookingFormFields @include(if: $withCustomBookingFormFields) {
      id
      inputType
      name
      label
      info
      value
      required
    }
  }
}`
